module.exports = __webpack_public_path__ + "static/media/OURCOMPANY.99241170.png";